import { Avatar, Box, Grid, GridItem, Text, HStack, VStack } from "@chakra-ui/react"

interface Props {
  searchResults: any[]
  selectedTempPatient: any | null
  setSelectedTempPatient: React.Dispatch<React.SetStateAction<any | null>>
}

const FoundedPatients: React.FC<Props> = ({ 
  searchResults, 
  selectedTempPatient, 
  setSelectedTempPatient 
}) => {
  const handleSelectTempPatient = (temPat: any) => {
    if (temPat?.id === selectedTempPatient?.id) {
      setSelectedTempPatient(null)
    } else {
      setSelectedTempPatient(temPat)
    }
  }

  return (
    <Grid 
      templateColumns="repeat(12, 1fr)" 
      gap={2} 
      mt={3} 
      maxH="300px" 
      overflowY="auto"
      className="custom-scroll"
    >
      {searchResults?.map((item, index) => (
        <GridItem key={index} colSpan={{ base: 12, lg: 6 }}>
          <Box
            border={item?.id === selectedTempPatient?.id ? "1px solid" : "none"}
            borderColor="#215EE0"
            borderRadius="8px"
            cursor="pointer"
            onClick={() => handleSelectTempPatient(item)}
            px="9px"
            py="8px"
            transition="all 0.2s"
            _hover={{ 
              bg: item?.id === selectedTempPatient?.id ? "transparent" : "gray.50" 
            }}
          >
            <HStack spacing={2} align="center">
              <Avatar
                size="sm"
                w="31px"
                h="31px"
                bg="#DBEAFE"
                color="#2563EB"
                fontSize="12px"
                fontWeight={500}
                name={`${item?.family?.charAt(0)?.toUpperCase()} ${item?.name[0]?.charAt(0)?.toUpperCase()}`}
              >
              
              </Avatar>
              <VStack spacing={0} align="flex-start">
                <Text fontSize="16px" fontWeight={500} color="#161616">
                  {`${item?.family} ${item?.name[0]}`}
                </Text>
                <Text fontSize="12px" fontWeight={400} color="#6C737F">
                  {item?.identifier} • {item?.gender} • {item?.birthDate}
                </Text>
              </VStack>
            </HStack>
          </Box>
        </GridItem>
      ))}
    </Grid>
  )
}

export default FoundedPatients